import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeGallery01 from './HomeGallery_01';
import HomeGallery02 from './HomeGallery_02';
import HomeGallery03 from './HomeGallery_03';
import HomeGallery04 from './HomeGallery_04';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        <>
            {
            layout.current === 'home-gallery-01' ?
                <HomeGallery01 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-gallery-02' ?
                <HomeGallery02 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-gallery-03' ?
                <HomeGallery03 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
            layout.current === 'home-gallery-04' ?
                <HomeGallery04 pag_welcome={pw.current} dados_config={dados_config.current} />
            :
                <HomeGallery01 pag_welcome={pw.current} dados_config={dados_config.current} />
            }
        </>
    )
}
